import { navigate } from 'gatsby-link'
import React, { useEffect, useState } from 'react'

function getQueryParam(url, param) {
  const urlParams = new URLSearchParams(url)
  return urlParams.get(param)
}

function decodeJwt(token) {
  if (!token) return null

  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace('-', '+').replace('_', '/')

  return JSON.parse(window.atob(base64))
}

function readStoredLoginToken() {
  if (typeof window === 'undefined') return null

  const urlToken = getQueryParam(window.location.search, 'doggos_l')
  if (urlToken) {
    window.localStorage.setItem('doggos_l', urlToken)
    return urlToken
  }

  return window.localStorage.getItem('doggos_l')
}

export const useProfileData = (options = {}) => {
  const withSession = Boolean(options.withSession)
  const optional = Boolean(options.optional)

  const [data, setData] = useState(() => {
    if (typeof window === 'undefined' || withSession) return null
    return decodeJwt(readStoredLoginToken())
  })
  const [isLoading, setIsLoading] = useState(
    () => typeof window !== 'undefined'
  )
  const [error, setError] = useState(null)

  useEffect(() => {
    if (typeof window === 'undefined') return undefined

    let cancelled = false

    const fetchData = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const l = readStoredLoginToken()

        if (!l) {
          if (!optional) {
            navigate('/', {
              replace: true,
              state: {
                returnTo: window.location.href,
              },
            })
          } else {
            console.debug('Anonymous user')
          }

          if (!cancelled) setData(null)
          return
        }

        const response = await fetch('/api/login', {
          method: 'post',
          body: JSON.stringify({ l }),
        })

        if (!response.ok) {
          if (!optional) {
            window.localStorage.removeItem('doggos_l')
            navigate('/', {
              replace: true,
              state: {
                returnTo: window.location.href,
              },
            })
          }
          if (!cancelled) setData(null)
          return
        }

        const login = await response.json()
        window.localStorage.setItem('doggos_l', login.l)

        const profile = decodeJwt(login.l)
        if (!cancelled) {
          setData(
            withSession ? { profile, token: login.l } : profile
          )
        }
      } catch (cause) {
        if (!cancelled) setError(cause)
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }

    fetchData()

    const onLogout = () => {
      if (!cancelled) setData(null)
    }
    window.addEventListener('doggos-auth-logout', onLogout)

    return () => {
      cancelled = true
      window.removeEventListener('doggos-auth-logout', onLogout)
    }
  }, [withSession, optional])

  if (withSession) {
    return {
      profile: data?.profile ?? null,
      userToken: data?.token ?? null,
      isLoading,
      error,
    }
  }

  return data
}

function AuthProvider(props) {
  useEffect(() => {
    const loginJWT = getQueryParam(window.location.search, 'doggos_l')

    if (loginJWT) {
      console.debug('found JWT')
      localStorage.setItem('doggos_l', loginJWT)
      navigate('/dashboard', { replace: true })
    }
  }, [])

  return props.children
}

export default AuthProvider
